<template>
	<div class="modal">
		<div class="modal-wrapper" :style="{ width: modalWidth + 'px', maxWidth: '90vw' }">
			<div class="modal-top">
				<button class="transparent close-modal" v-on:click="$emit('close')">x</button>
			</div>
			<div class="modal-content">
				<slot />
			</div>
		</div>
	</div>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    modalWidth: {
      type: Number,
      default: 700
    }
  }
}
</script>
